import Config from 'APP/Config'
import { AdminArea } from 'APP/Config/types'
import I18n, { isTranslationKey } from 'APP/I18n'

export type AdminAreaWithLabel = AdminArea & {
  label: string
  value: string
}

export const getAdminAreas = (): AdminAreaWithLabel[] =>
  Config.ADMIN_AREAS.map((adminArea: AdminArea) => {
    const labelKey = `AdminAreas.${Config.REGION}.${adminArea.key}`
    return {
      ...adminArea,
      label: isTranslationKey(labelKey) ? I18n.t(labelKey) : adminArea.key,
      value: adminArea.key,
    }
  })

export default {
  getAdminAreas,
}
